import { store } from '@/redux/store';
import { configurationSelector } from '@/redux/configuration/configuration.selectors';

export const getMinervaVersion = (): string => {
  const configurationState = configurationSelector(store.getState());
  return configurationState.main.data?.version ?? '0.0.0';
};
